"use client";

import { Core } from "@faire/design-tokens";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated use `@faire/slate/icons/NotificationBell` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const NotificationBell = createSVGIcon(
  <path
    d="M9.171 20.133a2.71 2.71 0 0 0 2.622 2.028 2.71 2.71 0 0 0 2.622-2.028M12.15 2.015c1.864 0 3.652.768 4.97 2.136a7.43 7.43 0 0 1 2.059 5.157c0 8.11 2.85 8.327 3.621 8.327H1.5c.786 0 3.621-.235 3.621-8.327 0-1.934.74-3.79 2.059-5.157a6.9 6.9 0 0 1 4.97-2.136Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "NotificationBell",
  (strictLocalize) => ({
    color: Core.icon.default,
    fill: "none",
    titleAccess: strictLocalize({
      id: "u3K8H2",
      defaultMessage: "Notification",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
    className: legacyIconCls(),
  })
);
